import React, { FC, useState } from 'react';
import { useFormContext, useController } from 'react-hook-form';
import JobTitleContents from '@components/match/profile/profileCard/jobGroupTitlesSelectModal/jobGroupTitleContents/JobTitleContents';
import { JobGroupWithTitlesDescDto } from '@domain/rs/code/JobGroupsWithTitlesRs';

import classnames from 'classnames/bind';
import styles from '../jobSelectModal.module.scss';
const cx = classnames.bind(styles);

export const jobTitleNNamePrefix = 'jobGroup';
const jobGroupFieldName = 'jobGroupCode';
const jobTitleFieldName = 'jobTitleCodes';

interface IJobGroupCardProps {
  vo: JobGroupWithTitlesDescDto;
  namePrefix: string;
  on: boolean;
  onClickTab: () => void;
}

const JobGroupCard: FC<IJobGroupCardProps> = ({ vo, namePrefix, on, onClickTab }) => {
  const { control, watch } = useFormContext();
  const watchCount = watch(`${namePrefix}.${jobTitleFieldName}`);
  const selectedCount = watchCount?.length ?? 0;

  const { field } = useController({
    control,
    name: `${namePrefix}.${jobGroupFieldName}`,
    defaultValue: vo.code,
  });

  return (
    <li className={cx('listItem')}>
      <a className={cx('btnJobGroup', { on })} role="button" onClick={onClickTab}>
        {vo.name}
        <span className={cx('count')}>{selectedCount}</span>
      </a>
    </li>
  );
};

interface IJobTitleContentsProps {
  visible: boolean;
  jobGroupFieldName: string;
}

const JobGroupTitleContents: FC<IJobTitleContentsProps> = ({ visible, jobGroupFieldName }) => {
  const [tab, setTab] = useState(0);
  const { watch } = useFormContext();
  const watchJobGroups = watch(jobGroupFieldName) as JobGroupWithTitlesDescDto[];

  const jobGroupListEl = watchJobGroups
    ?.sort((a, b) => a.code - b.code)
    .map((item, idx: number) => {
      return (
        <JobGroupCard
          key={item.code}
          vo={item}
          namePrefix={`${jobTitleNNamePrefix}[${idx}]`}
          on={tab === idx}
          onClickTab={() => setTab(idx)}
        />
      );
    });

  return (
    <div className={cx('jobSelectArea', { hidden: !visible })}>
      <div className={cx('jobGroupArea')}>
        <ul className={cx('jobGroupList')}>{jobGroupListEl}</ul>
      </div>

      <div className={cx('jobArea')}>
        <JobTitleContents
          activeTab={tab}
          namePrefix={jobTitleNNamePrefix}
          jobGroupFieldName={jobGroupFieldName}
          jobTitleFieldName={jobTitleFieldName}
        />
      </div>
    </div>
  );
};

export default JobGroupTitleContents;
